import { Flex, Loader, ScrollArea, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import MobileBottomDrawer from '@/components/ui/MobileBottomDrawer';
import { ChartTipEntity } from '@/entities/ChartTips';
import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';

import s from './MobileChartTipsDrawer.module.scss';

const MobileChartTipsDrawer: React.FC = () => {
  const { chartTipsStore, fieldText } = useOrganizationChatAiPageStore();
  const [opened, setOpened] = React.useState(false);

  React.useEffect(() => {
    if (chartTipsStore.meta.isInitialMetaState) {
      chartTipsStore.fetchChartTips();
    }
  }, [chartTipsStore]);

  const tips = chartTipsStore.collection.items;
  const hasTips = tips.length > 0;
  const isLoading = chartTipsStore.meta.isLoading || chartTipsStore.meta.isInitialMetaState;

  const handleOpen = React.useCallback(() => {
    if (!hasTips && !isLoading) {
      return;
    }

    setOpened(true);
  }, [hasTips, isLoading]);

  const handleClose = React.useCallback(() => {
    setOpened(false);
  }, []);

  const handleTipClick = React.useCallback(
    (tip: ChartTipEntity) => {
      fieldText.setValue(tip.suggestion);
      setOpened(false);
    },
    [fieldText],
  );

  if (!hasTips && !isLoading) {
    return null;
  }

  return (
    <>
      <BaseClickable className={s.root__trigger} onClick={handleOpen} ariaLabel="Открыть подсказки" withHover>
        <Text size="sm" fw={500} className={s['root__trigger-text']}>
          Подсказки
        </Text>
        <IconChevronRight size={16} className={s['root__trigger-icon']} />
      </BaseClickable>
      <MobileBottomDrawer
        opened={opened}
        onClose={handleClose}
        title="Подсказки"
        contentClassName={s.root}
        className={s['root__drawer-size']}
      >
        <ScrollArea.Autosize className={s.root__list} mah="100%" scrollbarSize={6} offsetScrollbars>
          {isLoading ? (
            <Flex justify="center" align="center" className={s.root__loader}>
              <Loader size="sm" />
            </Flex>
          ) : (
            <div className={s.root__items}>
              {tips.map((tip) => (
                <BaseClickable
                  key={tip.id}
                  className={s.root__item}
                  block
                  onClickWithValue={handleTipClick}
                  value={tip}
                >
                  <Text size="sm" fw={600} className={s['root__item-text']}>
                    {tip.suggestion}
                  </Text>
                </BaseClickable>
              ))}
            </div>
          )}
        </ScrollArea.Autosize>
      </MobileBottomDrawer>
    </>
  );
};

export default observer(MobileChartTipsDrawer);
